<template>
  <div class="ecs-fab-column">
    <div class="ecs-fab-column-top">
      <slot></slot>
    </div>
    <div class="ecs-fab-column-bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "FabColumn"
}
</script>

<style scoped>
  .ecs-fab-column{
    position: absolute;
    top: 0.75rem;
    right: clamp(1.25rem, 2vw, 2rem);
    bottom: 0.75rem;
    z-index: 30;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    pointer-events: none;
  }

  .ecs-fab-column-top,
  .ecs-fab-column-bottom{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: clamp(0.375rem, 1vw, 0.625rem);
    pointer-events: auto;
  }

  @media (orientation: landscape) and (max-height: 480px) {
    .ecs-fab-column{
      top: 0.5rem;
      right: clamp(1rem, 1.6vw, 1.25rem);
      bottom: 0.5rem;
    }
  }

</style>
